/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MonthlyVolume = {
    Under10: 'UNDER_10',
    From10To50: 'FROM_10_TO_50',
    From50To200: 'FROM_50_TO_200',
    Over200: 'OVER_200'
} as const;
export type MonthlyVolume = typeof MonthlyVolume[keyof typeof MonthlyVolume];

